import classNames from "classnames";
import { useState } from "react";
import HandleEvents from "Util/HandleEvents";
import { DirectorBoardDetailSection } from "./DirectorBoardDetailSection";
import { DirectorDto } from "./DirectorSectionTypes";
import { Badge } from "Views/Components/badge/badge";

export const DirectorBoardSection = ({ director }: { director: DirectorDto }) => {
	const [showBoardDetail, setShowBoardDetail] = useState<boolean>(false);
	const hasBoardDetails = director.totalCurrentBoardCount + director.totalPreviousBoardCount > 0;

	return (
		<div className="accordion-item">
			<div className="accordion-title-container">
				<h6 className="accordion-title-header">
					Business Involvements (Cross-Directorships)
					<Badge variant="info" morph="rounded-rectangular">
						{(director.totalCurrentBoardCount + director.totalPreviousBoardCount)}
					</Badge>
				</h6>
				{hasBoardDetails && (
					<span
						className={classNames('accordion-title-info accordion-icon icon-only icon-chevron-down', {
							open: showBoardDetail,
						})}
						{...HandleEvents(() => setShowBoardDetail(prev => !prev))}
					/>
				)}
			</div>
			<div className={classNames("accordion-content", {
				expanded: showBoardDetail,
				collapsed: !showBoardDetail
			})}>
				{showBoardDetail && (
					<>
						{director.totalCurrentBoardCount > 0 && (
							<DirectorBoardDetailSection directorId={director.id} isCurrent={true}/>
						)}
						{director.totalPreviousBoardCount > 0 && (
							<DirectorBoardDetailSection directorId={director.id} isCurrent={false}/>
						)}
					</>
				)}
			</div>
		</div>
	)
}